import Dashboard from 'app/features/dashboard';
import DashboardLayout from 'app/layout/dashboardLayout';
import { Route } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import ProtectedRoutes from 'utils/ProtectedRoutes';
import AccountantDetailsRoutes from './AccountantDetailsRoutes';
import ClientsRoutes from './ClientsRoutes';
import DocumentsRoutes from './DocumentsRoutes';
import HomeRoute from './HomeRoute';
import { lazy } from './lazyWithRetry';
import MessagesRoutes from './MessagesRoutes';
import NotificationsRoutes from './NotificationsRoutes';
import ProjectsRoutes from './ProjectsRoutes';
import TaskRoutes from './TaskRoutes';
import TaxEstimatesRoutes from './TaxEstimatesRoutes';
import TaxExtensionsRoutes from './TaxExtensionsRoutes';
import BillingRoutes from './BillingRoutes'; // Import the Billing routes
import Payments from 'app/features/payments';
import CardSuccess from 'app/features/payments/redirectionPages/cardSuccess';
import PaymentFailed from 'app/features/payments/redirectionPages/paymentFailed';
import PaymentSuccessful from 'app/features/payments/redirectionPages/paymentSuccessful';
import LinkedInCallback from 'Components/LinkedIn/LinkedInCallback';
import FincenReportsRoutes from './FincenReportsRoutes';
import QuickBooksCallback from 'Components/Quickbooks/QuickbooksCallback';
const AccountantProfile = lazy(
  () =>
    import(
      'admin/features/accountants/viewAccountantsDetails/AccoutantProfile'
    ),
);

export default function AccountantRoutes() {
  const { isAccountant } = useAuth();
  if (!isAccountant) return null;
  return (
    <>
      <Route path="/linkedin/callback" element={<LinkedInCallback />} />{' '}
      <Route path="/quickbooks/callback" element={<QuickBooksCallback />} />
      {/* Move this outside of dashboard */}
      <Route element={<ProtectedRoutes user="ACCOUNTANT" />}>
        <Route
          path="/dashboard"
          element={<DashboardLayout internalPadding={false} />}
        >
          {HomeRoute()}
          {AccountantDetailsRoutes()}
          {TaxEstimatesRoutes()}
          {TaxExtensionsRoutes()}
          {NotificationsRoutes()}
          {ProjectsRoutes()}
          {DocumentsRoutes()}
          {TaskRoutes()}
          {ClientsRoutes()}
          {MessagesRoutes()}
          {BillingRoutes()} {/* Use the BillingRoutes here */}
          {FincenReportsRoutes()}
          <Route path="payments" element={<Payments />} />
          <Route path="payments/add-card/success" element={<CardSuccess />} />
          <Route path="payments/payment-failed" element={<PaymentFailed />} />
          <Route
            path="payments/payment-success"
            element={<PaymentSuccessful />}
          />
        </Route>
      </Route>
    </>
  );
}
